import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { liteRedirect } from "./liteRedirect";

export function LiteRedirect() {
  const { "*": path } = useParams();

  useEffect(() => {
    liteRedirect(path ?? "");
  }, [path]);

  return <></>;
}
